import React from 'react'
import Topbar from '../topbar/Topbar'
import Navbar from '../Navbar/Navbar'

const Header = () => {
  return (
    <header>
        <Topbar/>
        <Navbar/>
    </header>
  )
}

export default Header